<template>
  <div id="erro">
    <Loading :class="{ ocultar: state.loading }" />
    <SectionErro />
  </div>
</template>

<script setup>
import { onMounted, reactive } from 'vue'
import SectionErro from '@components/app/erro/partials/SectionErro.vue'
import Loading from '@components/global/loading/Loading.vue'

const state = reactive({
  loading: false
})

onMounted(() => {
  setTimeout(() => {
    state.loading = true
  }, 2000)
})
</script>
